import axios from "axios";

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || "",
    status: null,
    name: localStorage.getItem("name"),
    userId: localStorage.getItem("userId"),
    roles: localStorage.getItem("roles"),
    user: "",
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    userName: (state) => state.name,
    userID: (state) => state.userId,
    userRoles: (state) => state.roles,
    user: (state) => state.user,
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token) {
      localStorage.setItem("token", `Bearer ${token.access_token}`);
      localStorage.setItem("roles", token.roles.join(", "));
      localStorage.setItem("name", token.username);
      localStorage.setItem("userId", token.userId);

      state.status = "success";
      state.roles = token.roles.join(", ");
      state.user = token;
      state.name = token.username;
      state.userId = token.userId;
      state.token = `Bearer ${token.access_token}`;
    },
    auth_error(state) {
      state.status = "error";
    },
    getCode(state, data) {
      console.log(data);
    },
    checkCode(state, data) {
      console.log(data);
    },
    logout(state) {
      localStorage.removeItem("token");
      localStorage.removeItem("roles");
      localStorage.removeItem("name");
      localStorage.removeItem("userId");
      localStorage.removeItem("hasMainOrganization");
      localStorage.removeItem("roles");
      localStorage.removeItem("taskTypeM");
      localStorage.removeItem("taskType");

      state.status = "";
      state.token = "";
      state.name = "";
      state.userId = "";
      state.roles = "";
      state.user = "";
    },
    get_user_data(state, user) {
      state.user = user;
      // console.log(user)
    },
  },
  actions: {
    login({ commit, rootState }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post(
            `${rootState.api}token?username=${user.username}&password=${user.password}`
          )
          .then((resp) => {
            axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${resp.data.access_token}`;
            commit("auth_success", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      console.log("logout");
      return new Promise((resolve, reject) => {
        // eslint-disable-line
        commit("logout");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    getUserData({ commit, rootState }) {
      axios.get(`${rootState.api}ManyRoles/CurrentUser`).then((resp) => {
        const user = resp.data;
        // console.log(user)
        commit("get_user_data", user);
      });
    },
    sendCode({ commit, rootState }, code) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/SendConfirmedCode?login=${code}`)
          .then((resp) => {
            commit("getCode", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkCode({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `${rootState.api}User/CheckConfirmedCode?login=${obj.login}&code=${obj.code}`
          )
          .then((resp) => {
            commit("checkCode", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changePassword({ commit, rootState }, obj) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/CheckConfirmedCodeAndChangePassword`, obj)
          .then((resp) => {
            commit("checkCode", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
